(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('ListControlController', listControlController);

  listControlController.$inject = ['$scope', 'ListControlService', 'NotificationService', '$rootScope', 'FoundationApi', 'Upload', 'LangService','ngTableParams'];

  function listControlController($scope, ListControlService, NotificationService, $rootScope, FoundationApi, Upload, LangService, ngTableParams)
  {
    var vm = this;
    vm.listControl = [];
    vm.newListControl = '';
    vm.labelsPage = '';
    getListControl();

    LangService
      .getPageLabels({'page': 'menu.master.list-control'})
      .$promise
      .then(function(data) {
        vm.labelsPage = data.lang;
      });

    function getListControl() 
    {
      vm.filterListControl = "";

      if ($rootScope.allowedRoles([$rootScope.profiles.ROLE_ADMIN])) {
        ListControlService
          .getListControl()
          .$promise
          .then(function(data) {
            if (data.listControl) {
              vm.listControl = angular.copy(data.listControl);
              vm.showFilter = angular.copy(data.listControl);
              vm.getFiltered(angular.copy(data.listControl));
              return;
            }
            
            vm.showFilter = []
            vm.listControl = []
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, vm.labelsPage.error_get);
          });
      }
    }

    vm.getFiltered = () => {
      vm.tableParams = new ngTableParams({
          page: 1,
          count: 30,
      }, {
          total: vm.showFilter.length,
          getData: function($defer, params) {
            $defer.resolve(vm.showFilter.slice((params.page() - 1) * params.count(), params.page() * params.count()))
            params.total(vm.showFilter.length)
          }
      })
    }

    vm.filterItems = () => {     
      vm.showFilter = vm.listControl.filter((listControl) => {
        var obj = Object.values(listControl);
        
        return obj[1].indexOf(vm.filterListControl) !== -1;
      });

      vm.getFiltered();
    }

    $scope.register = function(data)
    {
      if (!vm.newListControl) {
        NotificationService.errorHandler(data, vm.labelsPage.alertCpfRequired);

        return false;
      }

      if (vm.listControl.indexOf(vm.newListControl.toLowerCase()) !== -1) {
        NotificationService.errorHandler(data, vm.labelsPage.alertCpfRequired);

        return false;
      }

      vm.listControl.push(vm.newListControl.toLowerCase());
      vm.listControl.sort();

      ListControlService
        .registerListControl({'cpf': vm.newListControl})
        .$promise
        .then(function(data) {
          vm.newListControl = '';
          getListControl();
          NotificationService.successHandler(data, vm.labelsPage.register_success)
        })
        .catch(function(data) {
          NotificationService.errorHandler(data, vm.labelsPage.error)
        })
    }

    vm.deleteListControl = function(cpf) 
    {
      vm.listControlSelected = cpf;
      FoundationApi.publish('deleteListControl', 'open');
    }

    vm.delete = function()
    {
      vm.listControl.splice(vm.listControl.indexOf(vm.listControlSelected), 1);

      ListControlService
        .deleteListControl({'cpf': vm.listControlSelected})
        .$promise
        .then(function (data) {
          getListControl();
          NotificationService.successHandler(data, vm.labelsPage.register_success);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.error);
        });

      FoundationApi.publish('deleteListControl', 'close');
    }

    vm.import = function () {
      FoundationApi.publish('importModal', 'open');
    }

    //Upload codes
    window.upload_file = upload_file;
    vm.file_explorer = file_explorer;

    var fileobj;
    
    function upload_file(e)
    {
      e.preventDefault();
      fileobj = e.dataTransfer.files[0];
      validateFileUpload(fileobj);
    }

    function file_explorer()
    {
      document.getElementById('selectfile').click();
      document.getElementById('selectfile').onchange = function() 
      {
        fileobj = document.getElementById('selectfile').files[0];
        validateFileUpload(fileobj);
      };
    }

    function validateFileUpload(file_obj)
    {
      vm.uploadedFile = null;
      if (file_obj != undefined) {
        if (file_obj.type !== 'text/csv' && file_obj.type !== 'application/vnd.ms-excel') {
          NotificationService.errorHandler(file_obj, vm.labelsPage.csv_error)
        } else {
          vm.uploadedFile = file_obj;
          NotificationService.successHandler(file_obj, vm.labelsPage.upload_success)
        }
      } else {
        NotificationService.errorHandler(file_obj, vm.labelsPage.error)
      }
    }

    vm.saveUploadedFile = () => {
      Upload.upload({
        url: frontUrl + '/list-control/uploadFile',
        file: vm.uploadedFile
      })
      .then(function (response) {
        vm.listControl = response.data.updated
        let message = vm.labelsPage.success
          .replace('{1}', response.data.inserts)
          .replace('{2}', response.data.exists);

        getListControl();

        NotificationService.successHandler(response,  message, 10000);
        vm.uploadedFile = null;
        FoundationApi.publish('importModal', 'close');
      })
      .catch(function(response) {
        NotificationService.errorHandler(response, vm.labelsPage.error)
      })
    }

  }
})();